import React from 'react';
import PropTypes from 'prop-types';
import styleType from 'react-style-proptype';

import RadarChart from './RadarChart';
import ComparisonBarChart from './ComparisonBarChart';
import phrasesType from '../proptypes/phrases';
import { comparisonOptionType } from '../proptypes/comparison-options';
import carouselType from '../proptypes/carousel';

const AttributesGraphs = ({
  title, layers, data, style, phrases, comparison, rotateComparison, carousel, ...rest
}) => (
  <div {...rest}>
    <div className="row">
      <div className="col-12 mb-3">
        <h3>{title}</h3>
      </div>
    </div>
    <div className="row">
      <div className="col-12 col-lg-7">
        <RadarChart
          layers={layers}
          data={data}
          style={style}
        />
      </div>
      <div className="col-12 col-lg-5">
        <ComparisonBarChart
          layers={layers}
          data={data}
          style={style}
          phrases={phrases}
          comparison={comparison}
          rotateComparison={rotateComparison}
          carousel={carousel}
        />
      </div>
    </div>
  </div>
);

AttributesGraphs.propTypes = {
  title: PropTypes.string.isRequired,
  layers: PropTypes.arrayOf(PropTypes.any).isRequired,
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
  style: styleType,
  phrases: phrasesType.isRequired,
  comparison: comparisonOptionType.isRequired,
  rotateComparison: PropTypes.func.isRequired,
  carousel: carouselType.isRequired,
};

AttributesGraphs.defaultProps = {
  style: {},
};

export default AttributesGraphs;
